export const ACTIVITY = {
  sedentary: 1.2,
  light: 1.375,
  moderate: 1.55,
  very: 1.725,
  extreme: 1.9,
};
export const GOAL_ADJ = { lose: -500, maintain: 0, gain: 400, muscle: 250, nutrition: 0 };

export function computePlan(p) {
  const age = Number(p.age) || 30;
  const h = Number(p.height) || 170;
  const w = Number(p.current_weight) || 70;
  const gender = (p.gender || "other").toLowerCase();
  const bmr = 10 * w + 6.25 * h - 5 * age + (gender === "male" ? 5 : -161);
  const tdee = bmr * (ACTIVITY[p.activity_level] || 1.375);
  let cal = tdee + (GOAL_ADJ[p.goal] ?? 0);
  cal = Math.max(1200, Math.round(cal / 10) * 10);
  const pg = p.goal === "muscle" || p.goal === "lose" ? 1.9 : 1.6;
  const protein = Math.round(pg * w);
  const fat = Math.round((cal * 0.27) / 9);
  const carbs = Math.max(0, Math.round((cal - protein * 4 - fat * 9) / 4));
  const fiber = Math.max(25, Math.round((cal / 1000) * 14));
  return {
    calorie_goal: Math.round(cal),
    protein_goal: protein,
    carb_goal: carbs,
    fat_goal: fat,
    fiber_goal: fiber,
  };
}

export const GOAL_LABELS = {
  lose: "Lose weight",
  maintain: "Maintain weight",
  gain: "Gain weight",
  muscle: "Build muscle",
  nutrition: "Improve nutrition",
};
export const ACTIVITY_LABELS = {
  sedentary: "Mostly sedentary",
  light: "Lightly active",
  moderate: "Moderately active",
  very: "Very active",
  extreme: "Extremely active",
};
